import { Edit } from '@mui/icons-material'
import { Box, BoxProps, Button, ButtonProps, Link, Stack, StackProps, styled, Typography, TypographyProps } from '@mui/material'
import { ComponentProps, ComponentType } from 'react'

type StyledFormProps = ComponentProps<'form'> & { editing: boolean }

export const StyledForm: ComponentType<StyledFormProps> = styled( 'form', {
	shouldForwardProp: ( prop ) => prop !== 'editing',
} )<StyledFormProps>( ( { theme, editing } ) => ( {
	maxWidth: theme.spacing( 75 ),
	marginTop: theme.spacing( 2 ),
	paddingBottom: editing ? theme.spacing( 8 ) : theme.spacing( 2 ),
	display: 'flex',
	flex: 1,
	flexDirection: 'column',
} ) )

export const FooterContainer: ComponentType<BoxProps> = styled( Box )( ( { theme } ) => ( {
	backgroundColor: theme.palette.background.paper,
	borderTop: `1px solid ${theme.palette.grey[ 400 ]}`,
	bottom: 0,
	display: 'flex',
	justifyContent: 'space-between',
	left: 0,
	padding: theme.spacing( 2 ),
	paddingLeft: theme.spacing( 7 ),
	paddingRight: theme.spacing( 7 ),
	position: 'fixed',
	right: 0,
	height: theme.spacing( 6 ),
	zIndex: 1000,
	width: `calc(100vw - ${theme.spacing( 14 )})`,
} ) )

export const FooterButtonContainer: ComponentType<ComponentProps<typeof Box>> = styled( Box )( ( ) => ( {
	flex: 1,
	display: 'flex',
	justifyContent: 'space-between',
} ) )

export const BackLink: ComponentType<ComponentProps<typeof Link>> = styled( Link )( ( { theme } ) => ( {
	'textDecoration': 'none',
	'display': 'flex',
	'alignItems': 'center',
	'color': theme.palette.primary.main,
	'&:hover': {
		cursor: 'pointer',
		textDecoration: 'underline',
	},
} ) )

export const FormInputContainer: ComponentType<BoxProps> = styled( Box )<BoxProps>( ( ) => ( {
	display: 'flex',
	flexDirection: 'column',
	flex: 1,
} ) )

type DeleteButtonContainerProps = BoxProps & { editing: boolean }

export const DeleteButtonContainer: ComponentType<DeleteButtonContainerProps> = styled( Box, {
	shouldForwardProp: ( prop ) => prop !== 'editing',
} )<DeleteButtonContainerProps>( ( { theme, editing } ) => ( {
	flex: 1,
	justifyContent: 'flex-end',
	alignContent: 'flex-end',
	padding: editing ? theme.spacing( 4, 0 ) : theme.spacing( 4, 0, 0, 0 ),
} ) )

export const StyledDeleteButton: ComponentType<ButtonProps> = styled( Button )( ( { theme } ) => ( {
	padding: 0,
	backgroundColor: theme.palette.common.white,
} ) )

export const StyledCredentialsContainer: ComponentType<StackProps> = styled( Stack )( ( { theme } ) => ( {
	marginTop: theme.spacing( 4 ),
} ) )

export const LoadingContainer: ComponentType<BoxProps> = styled( Box )( {
	display: 'flex',
	justifyContent: 'flex-start',
	alignItems: 'center',
	height: '100%',
} )

export const StyledButton: ComponentType<ButtonProps> = styled( Button )( ( { theme } ) => ( {
	padding: 0,
	marginLeft: theme.spacing( 1 ),
	minWidth: 0,
} ) )

export const StyledEditIcon: ComponentType<ComponentProps<typeof Edit>> = styled( Edit )( ( { theme } ) => ( {
	width: 14,
	height: 14,
	border: `1px solid ${theme.palette.grey[ 400 ]}`,
	borderRadius: 4,
	padding: 4,
	color: theme.palette.grey[ 400 ],
	cursor: 'pointer',
} ) )

export const StyledHeaderTypography: ComponentType<TypographyProps> = styled( Typography )( ( { theme } ) => ( {
	fontFamily: theme.typography.fontFamily,
	fontSize: theme.typography.h3.fontSize,
	fontWeight: theme.typography.fontWeightMedium,
} ) )

export const DeleteWarningText: ComponentType<TypographyProps> = styled( Typography )( ( { theme } ) => ( {
	fontSize: '14px',
	color: '#757575',
	fontFeatureSettings: '"liga" off, "clig" off',
	fontFamily: theme.typography.fontFamily,
	fontWeight: theme.typography.fontWeightRegular,
	lineHeight: theme.typography.h5.lineHeight,
} ) )

export const DeleteWarningList: ComponentType<ComponentProps<'ul'>> = styled( 'ul' )( ( { theme } ) => ( {
	paddingLeft: theme.spacing( 2.5 ),
} ) )
